import { useState } from "react";
import { StyleSheet, Font, Svg, G, Path, Circle } from "@react-pdf/renderer";

import CalibriBold from "../../fonts/calibrib.ttf";
import Calibri from "../../fonts/calibri.ttf";

export const FontRegister = {
  family: "Calibri",
  fontStyle: "normal",
  fontWeight: "normal",
  fonts: [
    {
      src: Calibri,
    },
    {
      src: CalibriBold,
      fontWeight: "bold",
    },
  ],
};

// Create styles
export const DocStyles = StyleSheet.create({
  page: {
    paddingTop: "1.6cm",
    paddingBottom: "2.5cm",
    paddingHorizontal: "3cm",
  },
  section: {
    flexDirection: "row",
  },
  col: {
    flexGrow: 1,
  },
  logo: {
    textAlign: "right",
    marginBottom: "2cm",
  },
  heading: {
    fontSize: 22,
    textAlign: "center",
    textTransform: "uppercase",
    fontFamily: "Calibri",
    color: "#999999",
    marginBottom: "1.5cm",
  },
  title: {
    fontSize: 10,
    textAlign: "center",
    textTransform: "uppercase",
    fontWeight: 700,
    fontFamily: "Calibri",
    marginBottom: "1cm",
  },
  text: {
    fontSize: 10,
    fontFamily: "Calibri",
  },
  textRight: {
    fontSize: 10,
    fontFamily: "Calibri",
    textAlign: "right",
  },
  textCenter: {
    fontSize: 10,
    fontFamily: "Calibri",
    textAlign: "center",
  },
  textBold: {
    fontSize: 10,
    fontWeight: 700,
    fontFamily: "Calibri",
  },
  textBoldCenter: {
    fontSize: 10,
    fontWeight: 700,
    fontFamily: "Calibri",
    textAlign: "center",
  },
  textBoldRight: {
    fontSize: 10,
    fontWeight: 700,
    fontFamily: "Calibri",
    textAlign: "right",
  },
  paragraph: {
    fontSize: 10,
    textAlign: "justify",
    // textIndent: 50,
    fontFamily: "Calibri",
    marginBottom: "0.6cm",
  },
  paragraphRight: {
    fontSize: 10,
    textAlign: "right",
    // textIndent: 50,
    fontFamily: "Calibri",
    marginBottom: "0.6cm",
  },
  paragraphBold: {
    fontSize: 10,
    fontWeight: 700,
    // textIndent: 50,
    fontFamily: "Calibri",
    marginBottom: "0.6cm",
  },
  tableFact: {
    display: "flex",
    flexDirection: "row",
    marginBottom: "0.2cm",
  },
  tableFactCol: {
    flex: 1,
    padding: 10,
    border: "1px solid #757575",
  },
  tableDec: {
    display: "flex",
    flexDirection: "column",
  },
  tableRowHeader: {
    backgroundColor: "#f2f2f2",
    display: "flex",
    flexDirection: "row",
  },
  tableRow: {
    display: "flex",
    flexDirection: "row",
  },
  tableRowItem: {
    flex: 1,
    padding: 2,
    border: "1px solid #f2f2f2",
  },
  super : {
    verticalAlign: 'super',
    fontSize: 6,
  },
});

export function LogoTavad() {
  return (
    <Svg viewBox='0 0 300 80' style={{ width: 750, height: 40 }} fixed>
      <G>
        <G>
          <Path
            fill='#6F6F6E'
            d='M52,67.9l1.3-7.5H51l0.2-1.1h5.7l-0.2,1.1h-2.3l-1.3,7.5H52z'
          />
          <Path
            fill='#6F6F6E'
            d='M55.7,67.9l1-5.9h1l-0.2,1h0c0.2-0.3,0.4-0.6,0.8-0.8c0.3-0.2,0.7-0.3,1.1-0.3c0.2,0,0.3,0,0.4,0
				c0.1,0,0.2,0.1,0.3,0.1l-0.5,1c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4,0-0.6,0.1c-0.2,0.1-0.4,0.2-0.5,0.4
				c-0.2,0.2-0.3,0.3-0.4,0.6c-0.1,0.2-0.2,0.5-0.2,0.7l-0.5,3.1H55.7z'
          />
          <Path
            fill='#6F6F6E'
            d='M63.1,61.8c0.7,0,1.3,0.2,1.7,0.5c0.4,0.4,0.6,0.8,0.6,1.4c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3l-0.6,3.5h-1
				l0.1-0.8h0c-0.2,0.3-0.4,0.5-0.8,0.7c-0.3,0.2-0.7,0.3-1.1,0.3c-0.3,0-0.5,0-0.8-0.1c-0.2-0.1-0.4-0.2-0.6-0.4
				c-0.2-0.2-0.3-0.3-0.4-0.6c-0.1-0.2-0.2-0.5-0.2-0.7c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.3-0.5,0.6-0.7c0.2-0.2,0.5-0.3,0.9-0.4
				c0.3-0.1,0.7-0.2,1.1-0.2c0.3,0,0.6,0,0.8,0.1s0.5,0.2,0.7,0.3l0-0.3c0-0.1,0-0.1,0-0.2c0-0.3-0.1-0.6-0.4-0.8s-0.6-0.3-1-0.3
				c-0.3,0-0.6,0.1-0.8,0.2c-0.2,0.1-0.5,0.3-0.7,0.6L60.6,63c0.3-0.4,0.6-0.7,1-0.9C62.1,61.9,62.6,61.8,63.1,61.8z M62.1,67.1
				c0.2,0,0.5,0,0.7-0.1c0.2-0.1,0.4-0.2,0.6-0.4c0.2-0.2,0.3-0.3,0.4-0.6c0.1-0.2,0.2-0.4,0.2-0.7c-0.1-0.1-0.2-0.1-0.4-0.2
				c-0.1,0-0.3-0.1-0.5-0.1s-0.4-0.1-0.7-0.1c-0.2,0-0.4,0-0.6,0.1c-0.2,0-0.4,0.1-0.5,0.2c-0.1,0.1-0.3,0.2-0.4,0.4
				C61.1,65.8,61,66,61,66.2c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.1,0.3,0.2C61.8,67.1,61.9,67.1,62.1,67.1z'
          />
          <Path
            fill='#6F6F6E'
            d='M67.8,68.1c-0.2,0-0.4,0-0.5-0.1c-0.2-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.2-0.3-0.3-0.4
				c-0.1-0.2-0.1-0.4-0.1-0.6c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.4l0.5-3.1h-1l0.2-1h1l0.3-1.8h1.1L68.2,62h1.4l-0.2,1H68l-0.5,2.9
				c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.2c0,0.2,0,0.3,0.1,0.4C67.7,67,67.8,67,68,67c0.1,0,0.2,0,0.3,0s0.1,0,0.2-0.1l0.2,1
				C68.6,68,68.4,68,68.3,68C68.1,68,68,68.1,67.8,68.1z'
          />
          <Path
            fill='#6F6F6E'
            d='M72.9,61.8c0.7,0,1.3,0.2,1.7,0.5c0.4,0.4,0.6,0.8,0.6,1.4c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3l-0.6,3.5h-1
				l0.1-0.8h0c-0.2,0.3-0.4,0.5-0.8,0.7c-0.3,0.2-0.7,0.3-1.1,0.3c-0.3,0-0.5,0-0.8-0.1s-0.4-0.2-0.6-0.4c-0.2-0.2-0.3-0.3-0.4-0.6
				c-0.1-0.2-0.2-0.5-0.2-0.7c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.3-0.5,0.6-0.7c0.2-0.2,0.5-0.3,0.9-0.4c0.3-0.1,0.7-0.2,1.1-0.2
				c0.3,0,0.6,0,0.8,0.1c0.2,0.1,0.5,0.2,0.7,0.3l0-0.3c0-0.1,0-0.1,0-0.2c0-0.3-0.1-0.6-0.4-0.8c-0.2-0.2-0.6-0.3-1-0.3
				c-0.3,0-0.6,0.1-0.8,0.2s-0.5,0.3-0.7,0.6L70.5,63c0.3-0.4,0.6-0.7,1-0.9C71.9,61.9,72.4,61.8,72.9,61.8z M71.9,67.1
				c0.2,0,0.5,0,0.7-0.1c0.2-0.1,0.4-0.2,0.6-0.4c0.2-0.2,0.3-0.3,0.4-0.6c0.1-0.2,0.2-0.4,0.2-0.7c-0.1-0.1-0.2-0.1-0.3-0.2
				c-0.1,0-0.3-0.1-0.5-0.1c-0.2,0-0.4-0.1-0.7-0.1c-0.2,0-0.4,0-0.6,0.1c-0.2,0-0.4,0.1-0.5,0.2c-0.1,0.1-0.3,0.2-0.4,0.4
				c-0.1,0.2-0.1,0.3-0.1,0.5c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.1,0.3,0.2C71.6,67.1,71.8,67.1,71.9,67.1z
				'
          />
          <Path
            fill='#6F6F6E'
            d='M76.4,62h1l-0.1,0.8h0c0.2-0.3,0.5-0.6,0.8-0.7c0.3-0.2,0.7-0.3,1.1-0.3c0.4,0,0.8,0.1,1.1,0.3
				c0.3,0.2,0.5,0.5,0.6,0.8c0.2-0.3,0.5-0.6,0.9-0.8c0.4-0.2,0.8-0.3,1.3-0.3c0.6,0,1,0.2,1.3,0.5c0.3,0.3,0.4,0.7,0.4,1.2
				c0,0.1,0,0.3,0,0.4c0,0.1,0,0.3-0.1,0.5l-0.6,3.4H83l0.6-3.5c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3c0-0.3-0.1-0.6-0.3-0.7
				c-0.2-0.2-0.4-0.3-0.8-0.3c-0.2,0-0.4,0.1-0.6,0.2s-0.4,0.2-0.5,0.4c-0.2,0.2-0.3,0.4-0.4,0.6c-0.1,0.2-0.2,0.4-0.2,0.7l-0.6,3.2
				h-1.1l0.6-3.5c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3c0-0.3-0.1-0.6-0.3-0.7c-0.2-0.2-0.4-0.3-0.8-0.3c-0.2,0-0.4,0.1-0.6,0.2
				c-0.2,0.1-0.4,0.2-0.5,0.4c-0.2,0.2-0.3,0.4-0.4,0.6c-0.1,0.2-0.2,0.4-0.2,0.7l-0.6,3.2h-1.1L76.4,62z'
          />
          <Path
            fill='#6F6F6E'
            d='M85.4,67.9l1-5.9h1.1l-1,5.9H85.4z M87.3,60.8c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.6
				c0-0.2,0.1-0.4,0.2-0.5c0.1-0.2,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2c0.1,0.2,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.6
				C87.7,60.7,87.5,60.8,87.3,60.8z'
          />
          <Path
            fill='#6F6F6E'
            d='M93.3,66.5c-0.3,0.5-0.7,0.9-1.2,1.2c-0.5,0.3-1,0.4-1.5,0.4c-0.4,0-0.8-0.1-1.1-0.2
				c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.4-0.5-0.5-0.8c-0.1-0.3-0.2-0.7-0.2-1c0-0.5,0.1-0.9,0.2-1.3c0.2-0.4,0.4-0.8,0.7-1.1
				c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.9-0.3,1.4-0.3c0.4,0,0.7,0.1,1,0.2c0.3,0.1,0.6,0.3,0.8,0.5s0.4,0.5,0.5,0.8
				c0.1,0.3,0.2,0.6,0.2,1c0,0.1,0,0.3,0,0.5c0,0.2,0,0.3-0.1,0.4h-4.5c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.2c0,0.3,0,0.5,0.1,0.7
				c0.1,0.2,0.2,0.4,0.4,0.5c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.4,0.1,0.6,0.1c0.4,0,0.7-0.1,1-0.3c0.3-0.2,0.6-0.4,0.8-0.8
				L93.3,66.5z M92.6,64.2v-0.1c0-0.2,0-0.3-0.1-0.5c-0.1-0.2-0.1-0.3-0.3-0.4c-0.1-0.1-0.3-0.2-0.4-0.3c-0.2-0.1-0.4-0.1-0.6-0.1
				c-0.5,0-0.9,0.1-1.2,0.4c-0.3,0.3-0.6,0.6-0.7,1H92.6z'
          />
          <Path
            fill='#6F6F6E'
            d='M96,62.8L96,62.8c0.2-0.3,0.5-0.5,0.8-0.7c0.3-0.2,0.7-0.3,1.1-0.3c0.6,0,1,0.2,1.3,0.5
				c0.3,0.3,0.5,0.8,0.5,1.3c0,0.1,0,0.3,0,0.4c0,0.2,0,0.3-0.1,0.5l-0.6,3.4h-1.1l0.6-3.5c0-0.2,0-0.3,0-0.5c0-0.4-0.1-0.6-0.3-0.8
				c-0.2-0.2-0.5-0.3-0.9-0.3c-0.2,0-0.5,0-0.7,0.1s-0.4,0.2-0.5,0.4s-0.3,0.4-0.4,0.6c-0.1,0.2-0.2,0.5-0.2,0.7l-0.6,3.2h-1.1
				l1-5.9h1L96,62.8z'
          />
          <Path
            fill='#6F6F6E'
            d='M102.4,68.1c-0.2,0-0.4,0-0.5-0.1c-0.2-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.2-0.3-0.3-0.4s-0.1-0.4-0.1-0.6
				c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.4l0.5-3.1h-1l0.2-1h1l0.3-1.8h1.1l-0.3,1.8h1.4l-0.2,1h-1.4l-0.5,2.9c0,0.1,0,0.2,0,0.3
				c0,0.1,0,0.2,0,0.2c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2-0.1l0.2,1
				c-0.2,0.1-0.3,0.1-0.5,0.1C102.8,68,102.6,68.1,102.4,68.1z'
          />
          <Path
            fill='#6F6F6E'
            d='M107.8,61.8c0.4,0,0.8,0.1,1.1,0.2c0.3,0.1,0.6,0.3,0.8,0.6c0.2,0.3,0.4,0.6,0.5,0.9
				c0.1,0.3,0.2,0.7,0.2,1.1c0,0.5-0.1,0.9-0.3,1.4c-0.2,0.4-0.4,0.8-0.7,1.1c-0.3,0.3-0.7,0.6-1.1,0.7c-0.4,0.2-0.9,0.3-1.4,0.3
				c-0.4,0-0.8-0.1-1.1-0.2c-0.3-0.1-0.6-0.4-0.8-0.6c-0.2-0.3-0.4-0.6-0.5-0.9c-0.1-0.3-0.2-0.7-0.2-1.1c0-0.5,0.1-0.9,0.3-1.4
				c0.2-0.4,0.4-0.8,0.7-1.1c0.3-0.3,0.7-0.6,1.1-0.7C106.8,61.9,107.3,61.8,107.8,61.8z M107.1,67.1c0.3,0,0.7-0.1,0.9-0.2
				c0.3-0.1,0.5-0.3,0.7-0.5c0.2-0.2,0.3-0.5,0.4-0.8c0.1-0.3,0.2-0.6,0.2-0.9c0-0.3,0-0.5-0.1-0.7c-0.1-0.2-0.2-0.4-0.4-0.6
				c-0.2-0.2-0.3-0.3-0.5-0.4c-0.2-0.1-0.4-0.1-0.6-0.1c-0.3,0-0.7,0.1-0.9,0.2c-0.3,0.1-0.5,0.3-0.7,0.5c-0.2,0.2-0.3,0.5-0.4,0.8
				c-0.1,0.3-0.2,0.6-0.2,0.9c0,0.3,0,0.5,0.1,0.7c0.1,0.2,0.2,0.4,0.4,0.6c0.2,0.2,0.3,0.3,0.5,0.4C106.7,67,106.9,67.1,107.1,67.1
				z'
          />
          <Path
            fill='#6F6F6E'
            d='M112.9,68.1c-0.3,0-0.6,0-0.9-0.1c-0.3-0.1-0.5-0.2-0.7-0.4c-0.2-0.1-0.3-0.3-0.5-0.5
				c-0.1-0.2-0.2-0.4-0.3-0.7l1-0.4c0.1,0.4,0.2,0.6,0.5,0.8c0.3,0.2,0.6,0.3,0.9,0.3c0.4,0,0.7-0.1,0.9-0.2
				c0.2-0.2,0.3-0.4,0.3-0.6c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.4-0.2-0.7-0.3l-0.7-0.2c-0.4-0.1-0.8-0.3-1-0.5s-0.4-0.6-0.4-1
				c0-0.3,0.1-0.5,0.2-0.7c0.1-0.2,0.3-0.4,0.5-0.6c0.2-0.2,0.5-0.3,0.7-0.4c0.3-0.1,0.6-0.1,0.9-0.1c0.5,0,1,0.1,1.4,0.4
				c0.4,0.3,0.6,0.6,0.8,1l-1,0.4c-0.1-0.2-0.2-0.4-0.4-0.6c-0.2-0.2-0.5-0.2-0.8-0.2c-0.3,0-0.6,0.1-0.8,0.2
				c-0.2,0.1-0.3,0.3-0.3,0.6c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.3,0.2,0.6,0.3l0.7,0.2c0.5,0.1,0.8,0.3,1.1,0.6s0.4,0.6,0.4,1
				c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.2-0.3,0.4-0.5,0.6c-0.2,0.2-0.5,0.3-0.8,0.4C113.6,68,113.3,68.1,112.9,68.1z'
          />
          <Path
            fill='#6F6F6E'
            d='M122.3,59.3h1.2l1.7,8.6H124l-0.4-2.3h-3.5l-1.2,2.3h-1.2L122.3,59.3z M123.4,64.5l-0.7-3.9h0l-2,3.9H123.4z
				'
          />
          <Path
            fill='#6F6F6E'
            d='M125.8,62h1.1l0.9,4.6h0l2.5-4.6h1.2l-3.3,5.9h-1.1L125.8,62z'
          />
          <Path
            fill='#6F6F6E'
            d='M134.5,61.8c0.7,0,1.3,0.2,1.7,0.5c0.4,0.4,0.6,0.8,0.6,1.4c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3l-0.6,3.5
				h-1l0.1-0.8h0c-0.2,0.3-0.4,0.5-0.8,0.7c-0.3,0.2-0.7,0.3-1.1,0.3c-0.3,0-0.5,0-0.8-0.1c-0.2-0.1-0.4-0.2-0.6-0.4
				c-0.2-0.2-0.3-0.3-0.4-0.6c-0.1-0.2-0.2-0.5-0.2-0.7c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.3-0.5,0.6-0.7c0.2-0.2,0.5-0.3,0.9-0.4
				c0.3-0.1,0.7-0.2,1.1-0.2c0.3,0,0.6,0,0.8,0.1s0.5,0.2,0.7,0.3l0-0.3c0-0.1,0-0.1,0-0.2c0-0.3-0.1-0.6-0.4-0.8s-0.6-0.3-1-0.3
				c-0.3,0-0.6,0.1-0.8,0.2s-0.5,0.3-0.7,0.6l-0.8-0.6c0.3-0.4,0.6-0.7,1-0.9C133.5,61.9,134,61.8,134.5,61.8z M133.5,67.1
				c0.2,0,0.5,0,0.7-0.1c0.2-0.1,0.4-0.2,0.6-0.4c0.2-0.2,0.3-0.3,0.5-0.6c0.1-0.2,0.2-0.4,0.2-0.7c-0.1-0.1-0.2-0.1-0.3-0.2
				c-0.1,0-0.3-0.1-0.5-0.1c-0.2,0-0.4-0.1-0.7-0.1c-0.2,0-0.4,0-0.6,0.1c-0.2,0-0.4,0.1-0.5,0.2c-0.1,0.1-0.3,0.2-0.4,0.4
				c-0.1,0.2-0.1,0.3-0.1,0.5c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.1,0.3,0.2
				C133.2,67.1,133.4,67.1,133.5,67.1z'
          />
          <Path
            fill='#6F6F6E'
            d='M138.9,62.8L138.9,62.8c0.2-0.3,0.5-0.5,0.8-0.7c0.3-0.2,0.7-0.3,1.1-0.3c0.6,0,1,0.2,1.3,0.5
				c0.3,0.3,0.5,0.8,0.5,1.3c0,0.1,0,0.3,0,0.4c0,0.2,0,0.3-0.1,0.5l-0.6,3.4H141l0.6-3.5c0-0.2,0-0.3,0-0.5c0-0.4-0.1-0.6-0.3-0.8
				s-0.5-0.3-0.9-0.3c-0.2,0-0.5,0-0.7,0.1c-0.2,0.1-0.4,0.2-0.5,0.4s-0.3,0.4-0.4,0.6c-0.1,0.2-0.2,0.5-0.2,0.7l-0.6,3.2H137l1-5.9
				h1L138.9,62.8z'
          />
          <Path
            fill='#6F6F6E'
            d='M143.2,66.9l3.9-3.9H144l0.2-1h4.5l-0.2,1l-3.9,3.9h3.3l-0.2,1h-4.6L143.2,66.9z'
          />
          <Path
            fill='#6F6F6E'
            d='M152,61.8c0.7,0,1.3,0.2,1.7,0.5c0.4,0.4,0.6,0.8,0.6,1.4c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3l-0.6,3.5h-1
				l0.1-0.8h0c-0.2,0.3-0.4,0.5-0.8,0.7c-0.3,0.2-0.7,0.3-1.1,0.3c-0.3,0-0.5,0-0.8-0.1s-0.4-0.2-0.6-0.4c-0.2-0.2-0.3-0.3-0.4-0.6
				c-0.1-0.2-0.2-0.5-0.2-0.7c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.3-0.5,0.6-0.7c0.2-0.2,0.5-0.3,0.9-0.4c0.3-0.1,0.7-0.2,1.1-0.2
				c0.3,0,0.6,0,0.8,0.1c0.2,0.1,0.5,0.2,0.7,0.3l0-0.3c0-0.1,0-0.1,0-0.2c0-0.3-0.1-0.6-0.4-0.8c-0.2-0.2-0.6-0.3-1-0.3
				c-0.3,0-0.6,0.1-0.8,0.2s-0.5,0.3-0.7,0.6l-0.8-0.6c0.3-0.4,0.6-0.7,1-0.9C151,61.9,151.5,61.8,152,61.8z M151,67.1
				c0.2,0,0.5,0,0.7-0.1c0.2-0.1,0.4-0.2,0.6-0.4c0.2-0.2,0.3-0.3,0.4-0.6c0.1-0.2,0.2-0.4,0.2-0.7c-0.1-0.1-0.2-0.1-0.4-0.2
				c-0.1,0-0.3-0.1-0.5-0.1c-0.2,0-0.4-0.1-0.7-0.1c-0.2,0-0.4,0-0.6,0.1c-0.2,0-0.4,0.1-0.5,0.2c-0.1,0.1-0.3,0.2-0.4,0.4
				c-0.1,0.2-0.1,0.3-0.1,0.5c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.1,0.3,0.2C150.7,67.1,150.9,67.1,151,67.1
				z'
          />
          <Path
            fill='#6F6F6E'
            d='M157,68.1c-0.3,0-0.6-0.1-0.9-0.2c-0.3-0.1-0.5-0.3-0.8-0.5c-0.2-0.2-0.4-0.5-0.5-0.9
				c-0.1-0.3-0.2-0.7-0.2-1.1c0-0.5,0.1-0.9,0.3-1.3c0.2-0.4,0.4-0.8,0.7-1.1c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.8-0.3,1.3-0.3
				c0.4,0,0.7,0.1,1.1,0.3c0.3,0.2,0.6,0.4,0.7,0.7h0l0.1-0.8l0.5-2.7h1.1l-1.5,8.6h-1l0.1-0.8h0c-0.2,0.3-0.5,0.5-0.8,0.7
				C157.9,68,157.5,68.1,157,68.1z M157.8,62.8c-0.3,0-0.6,0.1-0.8,0.2s-0.5,0.3-0.7,0.5s-0.3,0.5-0.5,0.8c-0.1,0.3-0.2,0.6-0.2,1
				c0,0.6,0.1,1,0.4,1.3c0.3,0.3,0.7,0.5,1.2,0.5c0.3,0,0.6-0.1,0.8-0.2s0.5-0.3,0.7-0.6s0.3-0.5,0.4-0.8c0.1-0.3,0.2-0.6,0.2-0.9
				c0-0.6-0.2-1-0.5-1.3C158.7,63,158.3,62.8,157.8,62.8z'
          />
          <Path
            fill='#6F6F6E'
            d='M164.7,61.8c0.4,0,0.8,0.1,1.1,0.2c0.3,0.1,0.6,0.3,0.8,0.6c0.2,0.3,0.4,0.6,0.5,0.9s0.2,0.7,0.2,1.1
				c0,0.5-0.1,0.9-0.3,1.4c-0.2,0.4-0.4,0.8-0.7,1.1c-0.3,0.3-0.7,0.6-1.1,0.7c-0.4,0.2-0.9,0.3-1.4,0.3c-0.4,0-0.8-0.1-1.1-0.2
				c-0.3-0.1-0.6-0.4-0.8-0.6c-0.2-0.3-0.4-0.6-0.5-0.9c-0.1-0.3-0.2-0.7-0.2-1.1c0-0.5,0.1-0.9,0.3-1.4c0.2-0.4,0.4-0.8,0.7-1.1
				c0.3-0.3,0.7-0.6,1.1-0.7S164.2,61.8,164.7,61.8z M164,67.1c0.3,0,0.7-0.1,0.9-0.2c0.3-0.1,0.5-0.3,0.7-0.5
				c0.2-0.2,0.3-0.5,0.4-0.8c0.1-0.3,0.2-0.6,0.2-0.9c0-0.3,0-0.5-0.1-0.7c-0.1-0.2-0.2-0.4-0.4-0.6c-0.2-0.2-0.3-0.3-0.5-0.4
				c-0.2-0.1-0.4-0.1-0.6-0.1c-0.3,0-0.7,0.1-0.9,0.2c-0.3,0.1-0.5,0.3-0.7,0.5c-0.2,0.2-0.3,0.5-0.4,0.8c-0.1,0.3-0.2,0.6-0.2,0.9
				c0,0.3,0,0.5,0.1,0.7c0.1,0.2,0.2,0.4,0.4,0.6c0.2,0.2,0.3,0.3,0.5,0.4C163.6,67,163.8,67.1,164,67.1z'
          />
          <Path
            fill='#6F6F6E'
            d='M169.8,68.1c-0.3,0-0.6,0-0.9-0.1c-0.3-0.1-0.5-0.2-0.7-0.4c-0.2-0.1-0.3-0.3-0.5-0.5
				c-0.1-0.2-0.2-0.4-0.3-0.7l1-0.4c0.1,0.4,0.2,0.6,0.5,0.8c0.3,0.2,0.6,0.3,0.9,0.3c0.4,0,0.7-0.1,0.9-0.2s0.3-0.4,0.3-0.6
				c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.4-0.2-0.7-0.3l-0.7-0.2c-0.4-0.1-0.8-0.3-1-0.5c-0.3-0.2-0.4-0.6-0.4-1c0-0.3,0.1-0.5,0.2-0.7
				c0.1-0.2,0.3-0.4,0.5-0.6c0.2-0.2,0.5-0.3,0.7-0.4c0.3-0.1,0.6-0.1,0.9-0.1c0.5,0,1,0.1,1.4,0.4c0.4,0.3,0.6,0.6,0.8,1l-1,0.4
				c-0.1-0.2-0.2-0.4-0.4-0.6c-0.2-0.2-0.5-0.2-0.8-0.2c-0.3,0-0.6,0.1-0.8,0.2c-0.2,0.1-0.3,0.3-0.3,0.6c0,0.2,0.1,0.3,0.2,0.4
				c0.1,0.1,0.3,0.2,0.6,0.3l0.7,0.2c0.5,0.1,0.8,0.3,1.1,0.6c0.3,0.3,0.4,0.6,0.4,1c0,0.3-0.1,0.6-0.2,0.8
				c-0.1,0.2-0.3,0.4-0.5,0.6c-0.2,0.2-0.5,0.3-0.8,0.4C170.5,68,170.2,68.1,169.8,68.1z'
          />
          <Path
            fill='#6F6F6E'
            d='M178,68.1c-0.3,0-0.6-0.1-0.9-0.2c-0.3-0.1-0.5-0.3-0.8-0.5c-0.2-0.2-0.4-0.5-0.5-0.9
				c-0.1-0.3-0.2-0.7-0.2-1.1c0-0.5,0.1-0.9,0.3-1.3c0.2-0.4,0.4-0.8,0.7-1.1c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.8-0.3,1.3-0.3
				c0.4,0,0.7,0.1,1.1,0.3s0.6,0.4,0.7,0.7h0l0.1-0.8l0.5-2.7h1.1l-1.5,8.6h-1l0.1-0.8h0c-0.2,0.3-0.5,0.5-0.8,0.7
				C178.9,68,178.5,68.1,178,68.1z M178.8,62.8c-0.3,0-0.6,0.1-0.8,0.2s-0.5,0.3-0.7,0.5c-0.2,0.2-0.3,0.5-0.5,0.8
				c-0.1,0.3-0.2,0.6-0.2,1c0,0.6,0.1,1,0.4,1.3c0.3,0.3,0.7,0.5,1.2,0.5c0.3,0,0.6-0.1,0.9-0.2s0.5-0.3,0.7-0.6s0.3-0.5,0.4-0.8
				s0.2-0.6,0.2-0.9c0-0.6-0.2-1-0.5-1.3C179.7,63,179.3,62.8,178.8,62.8z'
          />
          <Path
            fill='#6F6F6E'
            d='M187.5,66.5c-0.3,0.5-0.7,0.9-1.2,1.2c-0.5,0.3-1,0.4-1.5,0.4c-0.4,0-0.8-0.1-1.1-0.2
				c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.4-0.5-0.5-0.8c-0.1-0.3-0.2-0.7-0.2-1c0-0.5,0.1-0.9,0.2-1.3c0.1-0.4,0.4-0.8,0.7-1.1
				c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.9-0.3,1.4-0.3c0.4,0,0.7,0.1,1,0.2c0.3,0.1,0.6,0.3,0.8,0.5s0.4,0.5,0.5,0.8
				c0.1,0.3,0.2,0.6,0.2,1c0,0.1,0,0.3,0,0.5c0,0.2,0,0.3-0.1,0.4h-4.5c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.2c0,0.3,0,0.5,0.1,0.7
				c0.1,0.2,0.2,0.4,0.4,0.5c0.1,0.1,0.3,0.2,0.5,0.3s0.4,0.1,0.6,0.1c0.4,0,0.7-0.1,1-0.3c0.3-0.2,0.6-0.4,0.8-0.8L187.5,66.5z
				 M186.9,64.2v-0.1c0-0.2,0-0.3-0.1-0.5c-0.1-0.2-0.1-0.3-0.3-0.4c-0.1-0.1-0.3-0.2-0.4-0.3c-0.2-0.1-0.4-0.1-0.6-0.1
				c-0.5,0-0.9,0.1-1.2,0.4c-0.3,0.3-0.6,0.6-0.7,1H186.9z'
          />
          <Path fill='#6F6F6E' d='M190.9,67.9l1.5-8.6h1.1l-1.5,8.6H190.9z' />
          <Path
            fill='#6F6F6E'
            d='M196.7,61.8c0.7,0,1.3,0.2,1.7,0.5c0.4,0.4,0.6,0.8,0.6,1.4c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3l-0.6,3.5
				h-1l0.1-0.8h0c-0.2,0.3-0.4,0.5-0.8,0.7c-0.3,0.2-0.7,0.3-1.1,0.3c-0.3,0-0.5,0-0.8-0.1c-0.2-0.1-0.4-0.2-0.6-0.4
				c-0.2-0.2-0.3-0.3-0.4-0.6c-0.1-0.2-0.2-0.5-0.2-0.7c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.3-0.5,0.6-0.7c0.3-0.2,0.5-0.3,0.9-0.4
				c0.3-0.1,0.7-0.2,1.1-0.2c0.3,0,0.6,0,0.8,0.1c0.2,0.1,0.5,0.2,0.7,0.3l0-0.3c0-0.1,0-0.1,0-0.2c0-0.3-0.1-0.6-0.4-0.8
				c-0.2-0.2-0.6-0.3-1-0.3c-0.3,0-0.6,0.1-0.8,0.2s-0.5,0.3-0.7,0.6l-0.8-0.6c0.3-0.4,0.6-0.7,1-0.9
				C195.7,61.9,196.2,61.8,196.7,61.8z M195.7,67.1c0.2,0,0.5,0,0.7-0.1c0.2-0.1,0.4-0.2,0.6-0.4c0.2-0.2,0.3-0.3,0.4-0.6
				c0.1-0.2,0.2-0.4,0.2-0.7c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0-0.3-0.1-0.5-0.1c-0.2,0-0.4-0.1-0.7-0.1c-0.2,0-0.4,0-0.6,0.1
				c-0.2,0-0.4,0.1-0.5,0.2c-0.1,0.1-0.3,0.2-0.4,0.4c-0.1,0.2-0.1,0.3-0.1,0.5c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.1,0.2,0.2,0.3
				c0.1,0.1,0.2,0.1,0.3,0.2C195.4,67.1,195.5,67.1,195.7,67.1z'
          />
          <Path
            fill='#6F6F6E'
            d='M205.5,59.3h1.2l1.7,8.6h-1.2l-0.4-2.3h-3.5l-1.2,2.3h-1.2L205.5,59.3z M206.6,64.5l-0.7-3.9h0l-2,3.9H206.6
				z'
          />
          <Path
            fill='#6F6F6E'
            d='M211.5,68.1c-0.3,0-0.6-0.1-0.9-0.2c-0.3-0.1-0.5-0.3-0.8-0.5c-0.2-0.2-0.4-0.5-0.5-0.9
				c-0.1-0.3-0.2-0.7-0.2-1.1c0-0.5,0.1-0.9,0.3-1.3c0.2-0.4,0.4-0.8,0.7-1.1c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.8-0.3,1.3-0.3
				c0.4,0,0.7,0.1,1.1,0.3c0.3,0.2,0.6,0.4,0.7,0.7h0l0.1-0.8l0.5-2.7h1.1l-1.5,8.6h-1l0.1-0.8h0c-0.2,0.3-0.5,0.5-0.8,0.7
				C212.4,68,212,68.1,211.5,68.1z M212.4,62.8c-0.3,0-0.6,0.1-0.8,0.2c-0.3,0.1-0.5,0.3-0.7,0.5s-0.3,0.5-0.5,0.8
				c-0.1,0.3-0.2,0.6-0.2,1c0,0.6,0.1,1,0.4,1.3c0.3,0.3,0.7,0.5,1.2,0.5c0.3,0,0.6-0.1,0.9-0.2c0.3-0.1,0.5-0.3,0.7-0.6
				c0.2-0.2,0.3-0.5,0.4-0.8c0.1-0.3,0.2-0.6,0.2-0.9c0-0.6-0.2-1-0.5-1.3C213.2,63,212.8,62.8,212.4,62.8z'
          />
          <Path
            fill='#6F6F6E'
            d='M215.8,67.9l1-5.9h1.1l-1,5.9H215.8z M217.7,60.8c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.6
				c0-0.2,0.1-0.4,0.2-0.5c0.1-0.2,0.3-0.2,0.5-0.2s0.4,0.1,0.5,0.2s0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.6
				C218.1,60.7,217.9,60.8,217.7,60.8z'
          />
          <Path
            fill='#6F6F6E'
            d='M220.9,68.1c-0.4,0-0.7-0.1-1-0.2c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.4-0.5-0.5-0.9
				c-0.1-0.3-0.2-0.7-0.2-1.1c0-0.5,0.1-1,0.3-1.4c0.2-0.4,0.4-0.8,0.7-1.1c0.3-0.3,0.7-0.6,1.1-0.7s0.9-0.3,1.3-0.3
				c0.4,0,0.7,0.1,0.9,0.1c0.3,0.1,0.5,0.2,0.7,0.4c0.2,0.2,0.3,0.3,0.5,0.5c0.1,0.2,0.2,0.4,0.3,0.6l-1,0.4
				c-0.1-0.3-0.3-0.6-0.5-0.8c-0.2-0.2-0.6-0.3-1-0.3c-0.3,0-0.6,0.1-0.9,0.2s-0.5,0.3-0.7,0.5s-0.3,0.5-0.5,0.8
				c-0.1,0.3-0.2,0.6-0.2,1c0,0.2,0,0.5,0.1,0.7c0.1,0.2,0.2,0.4,0.3,0.6s0.3,0.3,0.5,0.4c0.2,0.1,0.4,0.1,0.7,0.1
				c0.4,0,0.7-0.1,1-0.3c0.3-0.2,0.5-0.5,0.7-0.8l0.9,0.4c-0.2,0.3-0.4,0.5-0.5,0.8c-0.2,0.2-0.4,0.4-0.6,0.5
				c-0.2,0.1-0.5,0.2-0.7,0.3C221.5,68,221.2,68.1,220.9,68.1z'
          />
          <Path
            fill='#6F6F6E'
            d='M226.9,68.1c-0.4,0-0.7-0.1-1-0.2c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.4-0.5-0.5-0.9
				c-0.1-0.3-0.2-0.7-0.2-1.1c0-0.5,0.1-1,0.3-1.4s0.4-0.8,0.7-1.1c0.3-0.3,0.7-0.6,1.1-0.7s0.9-0.3,1.3-0.3c0.3,0,0.7,0.1,0.9,0.1
				c0.3,0.1,0.5,0.2,0.7,0.4c0.2,0.2,0.3,0.3,0.5,0.5c0.1,0.2,0.2,0.4,0.3,0.6l-1,0.4c-0.1-0.3-0.3-0.6-0.5-0.8
				c-0.2-0.2-0.6-0.3-0.9-0.3c-0.3,0-0.6,0.1-0.9,0.2c-0.3,0.1-0.5,0.3-0.7,0.5c-0.2,0.2-0.3,0.5-0.5,0.8c-0.1,0.3-0.2,0.6-0.2,1
				c0,0.2,0,0.5,0.1,0.7c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.2,0.3,0.3,0.5,0.4c0.2,0.1,0.4,0.1,0.7,0.1c0.4,0,0.7-0.1,1-0.3
				c0.3-0.2,0.5-0.5,0.7-0.8l0.9,0.4c-0.2,0.3-0.4,0.5-0.5,0.8c-0.2,0.2-0.4,0.4-0.6,0.5c-0.2,0.1-0.5,0.2-0.7,0.3
				S227.2,68.1,226.9,68.1z'
          />
          <Path
            fill='#6F6F6E'
            d='M230.4,67.9l1-5.9h1.1l-1,5.9H230.4z M232.3,60.8c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.6
				c0-0.2,0.1-0.4,0.2-0.5s0.3-0.2,0.5-0.2s0.4,0.1,0.5,0.2c0.1,0.2,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.6
				C232.7,60.7,232.5,60.8,232.3,60.8z'
          />
          <Path
            fill='#6F6F6E'
            d='M236.4,61.8c0.4,0,0.8,0.1,1.1,0.2c0.3,0.1,0.6,0.3,0.8,0.6c0.2,0.3,0.4,0.6,0.5,0.9
				c0.1,0.3,0.2,0.7,0.2,1.1c0,0.5-0.1,0.9-0.3,1.4c-0.2,0.4-0.4,0.8-0.7,1.1c-0.3,0.3-0.7,0.6-1.1,0.7c-0.4,0.2-0.9,0.3-1.4,0.3
				c-0.4,0-0.8-0.1-1.1-0.2c-0.3-0.1-0.6-0.4-0.8-0.6c-0.2-0.3-0.4-0.6-0.5-0.9c-0.1-0.3-0.2-0.7-0.2-1.1c0-0.5,0.1-0.9,0.3-1.4
				c0.2-0.4,0.4-0.8,0.7-1.1c0.3-0.3,0.7-0.6,1.1-0.7C235.5,61.9,235.9,61.8,236.4,61.8z M235.8,67.1c0.3,0,0.7-0.1,0.9-0.2
				c0.3-0.1,0.5-0.3,0.7-0.5c0.2-0.2,0.3-0.5,0.4-0.8c0.1-0.3,0.2-0.6,0.2-0.9c0-0.3,0-0.5-0.1-0.7c-0.1-0.2-0.2-0.4-0.4-0.6
				c-0.2-0.2-0.3-0.3-0.5-0.4c-0.2-0.1-0.4-0.1-0.6-0.1c-0.3,0-0.6,0.1-0.9,0.2c-0.3,0.1-0.5,0.3-0.7,0.5c-0.2,0.2-0.3,0.5-0.4,0.8
				c-0.1,0.3-0.2,0.6-0.2,0.9c0,0.3,0,0.5,0.1,0.7c0.1,0.2,0.2,0.4,0.4,0.6c0.2,0.2,0.3,0.3,0.5,0.4C235.3,67,235.5,67.1,235.8,67.1
				z M236.1,60.8l0.9-1.5h1.2l-1.1,1.5H236.1z'
          />
          <Path
            fill='#6F6F6E'
            d='M241.1,62.8L241.1,62.8c0.2-0.3,0.5-0.5,0.8-0.7c0.3-0.2,0.7-0.3,1.1-0.3c0.6,0,1,0.2,1.3,0.5
				c0.3,0.3,0.5,0.8,0.5,1.3c0,0.1,0,0.3,0,0.4c0,0.2,0,0.3-0.1,0.5l-0.6,3.4h-1.1l0.6-3.5c0-0.2,0-0.3,0-0.5c0-0.4-0.1-0.6-0.3-0.8
				c-0.2-0.2-0.5-0.3-0.9-0.3c-0.2,0-0.5,0-0.7,0.1s-0.4,0.2-0.5,0.4c-0.2,0.2-0.3,0.4-0.4,0.6c-0.1,0.2-0.2,0.5-0.2,0.7l-0.6,3.2
				h-1.1l1-5.9h1L241.1,62.8z'
          />
        </G>
        <Circle fill='#E09632' cx='8.2' cy='29.2' r='6.6' />
        <G>
          <Path
            fill='#E09632'
            d='M18.7,22.6c-1.6,0-3,0.6-4.2,1.5c1.1,1.4,1.8,3.2,1.8,5.1s-0.7,3.7-1.8,5.1c1.1,0.9,2.6,1.5,4.2,1.5
				c3.6,0,6.6-2.9,6.6-6.6C25.3,25.6,22.3,22.6,18.7,22.6z'
          />
        </G>
        <G>
          <Path
            fill='#E09632'
            d='M29.2,22.6c-1.6,0-3,0.6-4.2,1.5c1.1,1.4,1.8,3.2,1.8,5.1s-0.7,3.7-1.8,5.1c1.1,0.9,2.6,1.5,4.2,1.5
				c3.6,0,6.6-2.9,6.6-6.6C35.8,25.6,32.8,22.6,29.2,22.6z'
          />
        </G>
        <G>
          <Path
            fill='#6197FA'
            d='M34,22.6c2,1.5,3.4,3.9,3.4,6.6c0,2.7-1.3,5.1-3.4,6.6h12.8V22.6H34z'
          />
        </G>
        <Path
          fill='#6197FA'
          d='M51.5,22.8l-0.8,3.3H59c0,0,0.6,0,0.4,0.8c-0.2,0.8-5.9,23.6-5.9,23.6h9.3l4.3-17.7c0,0,0.9-5,2.9-5.9
			c2-0.9,3.8-0.8,3.8-0.8h3.5l0.9-3.3H51.5z'
        />
        <Path
          fill='#6197FA'
          d='M66.3,50.4h5.2l2.8-3.6c0,0,2.5-2.8,5-3.1c2.5-0.3,7.7-0.2,7.7-0.2l1.1-3.1h-7.3c0,0-1.3,0.2-1.3-0.6
			c-0.1-0.7,3.7-5.6,3.7-5.6l4.4-6.3c0,0,0.4-0.5,0.9-0.5c0.5,0,0.4,1,0.5,1.7c0.1,0.7,1.1,21.2,1.1,21.2h8.7l-1.7-27.6H86.5
			L66.3,50.4z'
        />
        <Path
          fill='#6197FA'
          d='M123.7,50.4h5.2l2.8-3.6c0,0,2.5-2.8,5-3.1c2.5-0.3,7.7-0.2,7.7-0.2l1.1-3.1h-7.3c0,0-1.3,0.2-1.3-0.6
			c-0.1-0.7,3.7-5.6,3.7-5.6l4.4-6.3c0,0,0.4-0.5,0.9-0.5s0.4,1,0.5,1.7c0.1,0.7,1.1,21.2,1.1,21.2h8.7l-1.7-27.6h-10.6L123.7,50.4z
			'
        />
        <Path
          fill='#6197FA'
          d='M106.6,50.4h10.4l16.7-27.6h-14.6l-0.8,2.9l2.7,0c0,0,2.5,0.2,3.1,1.3c0.5,1.1,0.9,2.4,0,4.1
			s-8.4,14.6-8.6,15c-0.3,0.5-0.4,0.6-0.9,0.6c-0.4,0-0.4-0.8-0.5-1.7c-0.1-0.5-1.9-22.2-1.9-22.2h-8.4L106.6,50.4z'
        />
        <Path
          fill='#6197FA'
          d='M165.6,22.8l-6.8,27.6h9.5c0,0,7-0.3,11-2c4-1.7,11.6-4.9,14.3-12c2.7-7-1.3-11.2-4.4-12.7s-12.2-1-12.2-1
			l-1,3.3c0,0,3.3-0.3,5.3,0.9c1.8,1.1,3.4,3.1,3.2,6.3c-0.1,2.3-0.5,6-4.4,9.4c-3.9,3.3-5.8,4-8.5,4.2c-2.7,0.3-2.8-0.3-2.5-1.6
			c0.3-1.3,5.5-22.6,5.5-22.6L165.6,22.8z'
        />
      </G>
    </Svg>
  );
}
